<template>
    <web
        :title="location.seo_title ?? location.name"
        :meta_description="location.meta_description"
        :location="location"
        :show-header="true"
        :show-footer="true"
        :show-breadcrumb="true"
        header-variant-setting="tour_listing_header_variant"
        header-display-setting="tour_listing_header"
    >
        <template #header="{ overlay }">
            <location-header
                :regions="regions"
                :location="location"
                :search="onSearch"
                :overlay-header="overlay"
                explore
            />
        </template>

        <div
            class="container px-2 mx-auto md:px-10 py-2 !mb-15 lg:!mb-0 flex flex-col gap-3"
        >
            <filter-component
                @submit="onSearch"
                :data="props.data"
                :meta="props.meta"
                explore
            />

            <tour-explorer
                :location="location"
                :sections="explore_sections"
                :loading="page_loading"
                @search="onSearch"
            />
        </div>
    </web>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import { Pagination, Tour, Location, Tag } from "@/types";
import Web from "@/Layouts/Web.vue";
import LocationHeader from "@/Components/LocationHeader.vue";
import FilterComponent from "@/Components/Tour/Filter.vue";
import TourExplorer from "@/Components/Tour/TourExplorer.vue";
import useAgency from "@/Hook/useAgency";

interface ExploreSection {
    id: number;
    type: string;
    title?: string | null;
    tag?: Tag | null;
    tours?: Tour[];
    position?: number;
}

const props = defineProps<{
    tours: Tour[];
    pagination: Pagination;
    meta:
        | {
              tour_categories: Tag[];
              tour_count_per_category?: Record<string, number>;
              min_price: number;
              max_price: number;
              min_duration: number;
              max_duration: number;
              min_rating: number;
              max_rating: number;
          }
        | any;
    location: Location;
    regions?: Location[];
    data: { [key: string]: any };
    explore_sections?: ExploreSection[];
}>();

const page_loading = ref(false);

const reseller = useAgency();

const onSearch = function (data: { [key: string]: any }, reset = false) {
    page_loading.value = true;

    const specific = usePage().props?.specific_tours;

    if (reseller.hasAgency.value) {
        data["agency_id"] = reseller.agencyId.value;
        data["agent_id"] = reseller.agent.value;
    }

    router.get(
        route(specific ? "specific.tours" : "tours", {
            country: props.location.country_slug,
            region: props.location.region_slug || undefined,
        }),
        {
            ...(reset ? {} : props.data),
            ...data,
            filter: true,
        },
        {
            onFinish: function () {
                page_loading.value = false;
            },
        },
    );
};
</script>

<style lang="scss" scoped>
.location-header {
    overflow: hidden;
}
</style>
